/** @format */

import {Box, IconButton, styled, TextField, Typography} from '@mui/material';

export const Container = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Header = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(2),
}));

export const HeaderLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '18px',
  lineHeight: '22px',
}));

export const RowContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledTextField = styled(TextField)(() => ({
  width: '200px',
}));

export const RemoveButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.semantic_dark?.bad.main,
}));

export const AddButtonWrapper = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
}));
